import { connectSockets } from '@editor2/services/socketService';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { checkResourceSyncOnVisible } from '@editor2/reducers/editor/effects';

export function useConnectSocket({ roomName, courseId }) {
	const dispatch = useDispatch();

	useEffect(() => {
		const subscriptions = connectSockets({ roomName, courseId });
		return () => {
			subscriptions.forEach((subscription) => subscription.unsubscribe());
		};
	}, [roomName, courseId]);

	// Bridge the websocket notification gap: a change made on another page (or
	// while this tab was hidden) can be missed, so re-check that our resource is
	// current every time the page becomes visible again.
	useEffect(() => {
		const onVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				dispatch(checkResourceSyncOnVisible({ courseId }));
			}
		};

		document.addEventListener('visibilitychange', onVisibilityChange);
		return () => {
			document.removeEventListener('visibilitychange', onVisibilityChange);
		};
	}, [courseId, dispatch]);
}
